import { DomPortalOutlet } from '@angular/cdk/portal';

// Compatibility shim for ngx-charts with Angular CDK v20+ portals.
// See: https://github.com/swimlane/ngx-charts/issues/2020

const originalAttachComponentPortal = (DomPortalOutlet.prototype as any)
  .attachComponentPortal;

(DomPortalOutlet.prototype as any).attachComponentPortal =
  function attachComponentPortal(portal: any) {
    const outlet = this as unknown as {
      _appRef?: { attachView?: (view: unknown) => void; injector?: unknown };
      _defaultInjector?: {
        get?: (...args: unknown[]) => unknown;
        attachView?: () => void;
        injector?: unknown;
      };
    };

  const hasAppRef = typeof outlet._appRef?.attachView === 'function';
  const hasDefaultInjectorGet = typeof outlet._defaultInjector?.get === 'function';

    if (
      !hasAppRef &&
      !hasDefaultInjectorGet &&
      outlet._defaultInjector?.attachView
    ) {
      const prevAppRef = outlet._appRef;
      const prevDefaultInjector = outlet._defaultInjector;

    outlet._appRef = outlet._defaultInjector as {
      attachView: (view: unknown) => void;
      injector?: unknown;
    };
    outlet._defaultInjector = outlet._appRef.injector as {
      get?: (...args: unknown[]) => unknown;
    };

      try {
        return originalAttachComponentPortal.call(this, portal);
      } finally {
        outlet._appRef = prevAppRef;
        outlet._defaultInjector = prevDefaultInjector;
      }
    }

    return originalAttachComponentPortal.call(this, portal);
  };
